import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = {
    errorMessage: { type: String, default: '' }
  }

  hide(event) {
    if (!event.target.classList.contains('close')) return

    this.#removeValidation()
    this.element.closest('.otp-modal').classList.add('hidden')
  }

  close(event) {
    if (
      !event.target.classList.contains('close') &&
      !event.target.closest('button').classList.contains('close')
    ) return

    this.#removeValidation()
    this.element.closest('.otp-modal').classList.add('hidden')
  }

  submit() {
    const modal = this.element.closest('.otp-modal')
    setTimeout(() => {
      if (!modal.querySelector('.error-message')) return

      Array.from({ length: 6 }).forEach((_, index) => {
        modal.querySelectorAll('input')[index].value = '';
      })
      modal.querySelector('input').focus()
    }, 500)
  }

  #removeValidation() {
    const modal = this.element.closest('.otp-modal')
    modal.querySelector('.otp-wrapper').classList.remove('error')
    modal.querySelector('.error-message')?.remove()
  }

}
